import script from "./PaperParse.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperParse.vue?vue&type=script&setup=true&lang=js"

import "./PaperParse.vue?vue&type=style&index=0&id=99ee5f82&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99ee5f82"]])

export default __exports__